module.exports = __webpack_public_path__ + "img/b6b070a.png";